import './card-grid.scss'
import { useLogger } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import type { CardGridCardTypes } from '@/common/model_builder/blockLists/cardGridCardTypes'
import { GenericCard } from './subcomponents/GenericCard'
import { VenueCard } from './subcomponents/VenueCard'

export const CardGrid: FC<{ cards: CardGridCardTypes }> = props => {
    const logger = useLogger('CardGrid')

    logger.trace('Rendering', props)

    if (!props.cards?.length) {
        logger.debug('No cards, nothing will be rendered.')
        return null
    }

    return (
        <div className="card-grid">
            {props.cards.map((card, index) => {
                if ('venue' in card) return <VenueCard {...card} key={index} />
                return <GenericCard key={index} {...card} />
            })}
        </div>
    )
}
